import { Translate } from '@chipinside/translate'

import Colors from '#/styles/Colors'

// Usa função para pegar as traduções
export const getCcomMarkersLegends = () => [
  {
    color: Colors.map.markers.ccom.operational,
    id: 'operational',
    label: Translate({ messageKey: 'connected' }),
    type: 'ccom',
  },
  {
    color: Colors.map.markers.ccom.waiting,
    id: 'waiting',
    label: Translate({ messageKey: 'dependent' }),
    type: 'ccom',
  },
  {
    color: Colors.map.markers.ccom.offline,
    id: 'offline',
    label: Translate({ messageKey: 'disconnected_singular' }),
    type: 'ccom',
  },
  {
    color: Colors.map.markers.ccom.inactive,
    id: 'inactive',
    label: Translate({ messageKey: 'inactive_female' }),
    type: 'ccom',
  },
]
